<div data-automation="dispatchableUnderfrequencyPanel" ngModelGroup="dispatchableFields">
    <ng-container>
        <div class="form-header form-header-subsection">
            {{ 'common.underfrequency' | translate }}
        </div>
        <!--- CREATE/EDIT --->
        <div *ngIf="(isCreateMode || isEditMode) && product" class="panel-content">
            <div class="form-group">
                <mat-grid-list cols="2" rowHeight="30px">
                    <mat-grid-tile>
                        <!--- require availability to dispatch --->
                        <div class="checkbox-wrapper">
                            <mat-checkbox
                                id="requireAvailabilityToDispatch"
                                #requireAvailabilityToDispatch="ngModel"
                                class="input-entry"
                                name="requireAvailabilityToDispatch"
                                [(ngModel)]="product.dispatchConf.requireAvailabilityToDispatch"
                                data-automation="requireAvailabilityToDispatch"
                                data-url-persist
                            >
                                {{ 'common.dispatch_conf.require_availability_to_dispatch' | translate }}
                            </mat-checkbox>

                            <mat-icon
                                matSuffix
                                svgIcon="enelx:general-info"
                                class="tooltip-icon"
                                [matTooltipPosition]="'below'"
                                matTooltip="{{
                                    'common.dispatch_conf.require_availability_to_dispatch.tooltip' | translate
                                }}"
                            ></mat-icon>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <!--- Zero Availability on Lock Out status --->
                        <div class="checkbox-wrapper">
                            <mat-checkbox
                                id="zeroRealtimeOnLockedOut"
                                #zeroRealtimeOnLockedOut="ngModel"
                                class="input-entry"
                                name="zeroRealtimeOnLockedOut"
                                [(ngModel)]="product.dispatchConf.zeroRealtimeOnLockedOut"
                                data-automation="zeroRealtimeOnLockedOut"
                                data-url-persist
                            >
                                {{ 'common.dispatch_conf.zero_realtime_on_locked_out' | translate }}
                            </mat-checkbox>

                            <mat-icon
                                matSuffix
                                svgIcon="enelx:general-info"
                                class="tooltip-icon"
                                [matTooltipPosition]="'below'"
                                matTooltip="{{
                                    'common.dispatch_conf.zero_realtime_on_locked_out.tooltip' | translate
                                }}"
                            ></mat-icon>
                        </div>
                    </mat-grid-tile>
                </mat-grid-list>
            </div>
        </div>

        <!--- VIEW --->
        <div *ngIf="isViewMode && product" class="panel-content">
            <div class="form-group">
                <div class="checkbox-container">
                    <!--- require availability to dispatch --->
                    <div class="form-entry">
                        <mat-label class="info-title"
                            >{{ 'common.dispatch_conf.require_availability_to_dispatch' | translate }}

                            <mat-icon
                                svgIcon="enelx:general-info"
                                data-automation="viewTitleTooltip"
                                class="tooltip-icon icon-container"
                                [matTooltipPosition]="'below'"
                                matTooltip="{{
                                    'common.dispatch_conf.require_availability_to_dispatch.tooltip' | translate
                                }}"
                            ></mat-icon>
                        </mat-label>
                        <mat-label class="input-entry" data-automation="requireAvailabilityToDispatch">
                            {{ product.dispatchConf.requireAvailabilityToDispatch }}
                        </mat-label>
                    </div>

                    <!--- show schedule offer tab --->
                    <div class="form-entry">
                        <mat-label class="info-title"
                            >{{ 'common.dispatch_conf.zero_realtime_on_locked_out' | translate }}

                            <mat-icon
                                svgIcon="enelx:general-info"
                                data-automation="viewTitleTooltip"
                                class="tooltip-icon icon-container"
                                [matTooltipPosition]="'below'"
                                matTooltip="{{
                                    'common.dispatch_conf.zero_realtime_on_locked_out.tooltip' | translate
                                }}"
                            ></mat-icon>
                        </mat-label>
                        <mat-label class="input-entry" data-automation="zeroRealtimeOnLockedOut">
                            {{ product.dispatchConf.zeroRealtimeOnLockedOut }}
                        </mat-label>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>
